import http from '../../../plugins/axios';

export default {
    getConfList(data) {
        return http.get({
            url: '/admin/siteconf/get',
            data: data
        });
    },
    updateConf(data) {
        return http.post({
            url: '/admin/siteconf/update',
            data: data,
            dataType: 'form'
        });
    },
    createConf(data) {
        return http.post({
            url: '/admin/siteconf/create',
            data: data,
            dataType: 'form'
        });
    },

    refreshConfigByKey(data) {
        return http.post({
            url : '/admin/siteconf/refresh',
            data : data,
            dataType: 'form'
        });
    }
};

